<template>
  <div class="contenedor-principal">
    <!-- Ventana central -->
    <div class="ventana-central">
      <!-- Botón de regresar -->
      <button class="btn-regresar" @click="regresar">
        <span class="material-icons">arrow_back</span>
      </button>

      <!-- Sección Izquierda: Login -->
      <div class="seccion seccion-login">
        <h2 class="titulo">Inicio de Sesión</h2>
        <form @submit.prevent="iniciarSesion">

          <div class="form-group">
            <label for="usuario">Usuario</label>
            <input type="text" id="usuario" v-model="usuario" placeholder="Ingresa tu usuario">
          </div>
          <div class="form-group">
            <label for="password">Contraseña</label>
            <input type="password" id="password" v-model="password" placeholder="Ingresa tu contraseña">
          </div>
          <button type="submit" class="btn-login">Iniciar Sesión</button>
        </form>
      </div>

      <!-- Sección Derecha: Fondo con logo -->
      <div class="seccion seccion-logo">
        <img src="@/assets/imagenes/logotipo_beige.png" alt="Logo">
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Swal from 'sweetalert2';

export default {
  name: 'LoginMedico',
  data() {
    return {
      usuario: '',
      password: ''
    };
  },
  methods: {
    ...mapActions(['login']),  // Esto asigna Vuex login() al componente

    async iniciarSesion() {
      if (!this.usuario.trim() || !this.password.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Campos vacíos',
          text: 'Por favor ingresa usuario y contraseña',
          confirmButtonColor: '#3085d6'
        });
        return;
      }

      const credenciales = {
        usuario: this.usuario,
        contraseña: this.password
      };

      const resultado = await this.$store.dispatch('login', credenciales);
      if (resultado.exito) {
        Swal.fire({
          icon: 'success',
          title: 'Inicio de sesión exitoso',
          text: 'Bienvenido/a',
          timer: 2000,
          showConfirmButton: false
        }).then(() => {
          this.$router.push(resultado.tipo === 'hotel' ? '/panel-hotel' : '/dashboard');
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error en el inicio de sesión',
          text: 'Usuario o contraseña incorrectos',
          confirmButtonColor: '#d33'
        });
      }
    },

    regresar() {
      this.$router.push('/');
    }
  }
};
</script>



  
  <style scoped>
  /* ============================================================
   DOMÉDICA - ESTILOS PARA PANTALLA DE LOGIN (DIVIDIDA)
   Basado en el Manual de Identidad (PDF)
   ============================================================ */

/* ---------- ANIMACIÓN DE ENTRADA ---------- */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ---------- CONTENEDOR PRINCIPAL (60% Dominante - Azul Profundo) ---------- */
.contenedor-principal {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: slideIn 0.5s ease forwards;
  background-color: var(--brand-primary); /* Azul profundo #133E68 */
}

/* ---------- VENTANA CENTRAL (Fondo Beige) ---------- */
.ventana-central {
  background: var(--brand-beige);           /* Beige #F4EFEB */
  border-radius: 20px;
  width: 70%;
  height: 80%;
  display: flex;
  overflow-y: auto;
  box-shadow: 0px 10px 30px rgba(19, 62, 104, 0.25); /* Sombra con tono de marca */
  position: relative;
}

/* ---------- BOTÓN DE REGRESAR (Acento secundario - Azul Profundo) ---------- */
.btn-regresar {
  position: absolute;
  top: 15px;
  left: 20px;
  background: none;
  border: none;
  color: var(--brand-primary);              /* Azul profundo */
  cursor: pointer;
  z-index: 10;
  transition: color 0.3s ease, transform 0.2s ease;
}

.btn-regresar:hover {
  color: var(--brand-accent-sage);          /* Verde Salvia en hover */
  transform: scale(1.1);
}

.btn-regresar .material-icons {
  font-size: 38px;
}

/* ---------- SECCIONES DENTRO DE LA VENTANA ---------- */
.seccion {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

/* ---------- SECCIÓN IZQUIERDA: LOGIN (Fondo Beige) ---------- */
.seccion-login {
  padding: 40px;
  background-color: var(--brand-beige);     /* Beige #F4EFEB */
}

/* ---------- TÍTULO (30% Secundario - Gris Oscuro) ---------- */
.titulo {
  font-size: 24px;
  font-weight: 700;
  color: var(--brand-secondary);            /* Gris oscuro #575756 */
  margin-bottom: 20px;
  text-align: center;
}

/* ---------- FORMULARIO ---------- */
.form-group {
  width: 100%;
  margin-bottom: 15px;
}

label {
  font-size: 14px;
  color: var(--brand-secondary);            /* Gris oscuro #575756 */
  font-weight: 600;
  display: block;
  margin-bottom: 4px;
}

/* ---------- INPUTS ---------- */
input {
  width: 100%;
  padding: 10px 14px;
  margin-top: 5px;
  border: 2px solid var(--brand-secondary-light); /* Gris claro #999999 */
  border-radius: 8px;
  font-size: 15px;
  color: var(--brand-secondary);            /* Gris oscuro #575756 */
  background-color: var(--white);
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

input:focus {
  outline: none;
  border-color: var(--brand-accent-sage);   /* Verde Salvia al enfocar */
  box-shadow: 0 0 0 4px rgba(96, 127, 112, 0.2);
}

input::placeholder {
  color: var(--brand-secondary-light);
  font-weight: 400;
}

/* ---------- BOTÓN DE LOGIN (10% Acento - Verde Salvia) ---------- */
.btn-login {
  width: 100%;
  padding: 12px;
  background: var(--brand-accent-sage);     /* Verde Salvia #607F70 */
  color: var(--white);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  margin-top: 10px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 12px rgba(96, 127, 112, 0.3);
}

.btn-login:hover {
  background: var(--brand-accent-sage-dark); /* #4A6255 (15% más oscuro) */
  color: var(--white);
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(96, 127, 112, 0.4);
}

.btn-login:active {
  transform: scale(0.96);
}

/* ---------- SECCIÓN DERECHA: LOGO CON DEGRADADO (Navy) ---------- */
.seccion-logo {
  background: var(--brand-accent-navy);     /* Azul Navy #305065 */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;
}

.seccion-logo img {
  width: 100%;
  height: auto;
  filter: brightness(1.1) contrast(1.05); /* Ligero realce para mejor visibilidad */
}

/* (Opcional) Texto adicional en la sección del logo */
.seccion-logo .texto-marca {
  color: var(--white);
  font-size: 18px;
  font-weight: 600;
  margin-top: 20px;
  text-align: center;
  opacity: 0.9;
}

/* ---------- TABLET (≤1024px) ---------- */
@media (max-width: 1024px) {
  .ventana-central {
    width: 80%;
    height: auto;
    flex-direction: row; /* mantiene side-by-side en tablet */
  }

  .seccion-login { padding: 32px 28px; }

  .seccion-logo img { width: 70%; }
}

/* ---------- MÓVIL (≤768px) ---------- */
@media (max-width: 768px) {
  .contenedor-principal {
    padding: 20px 16px;
    align-items: flex-start;
    padding-top: 40px;
  }

  .ventana-central {
    width: 100%;
    height: auto;
    flex-direction: column;
    border-radius: 16px;
  }

  /* Logo: banda compacta arriba */
  .seccion-logo {
    width: 100%;
    padding: 20px;
    min-height: unset;
    order: -1; /* va primero */
  }

  .seccion-logo img {
    width: auto;
    max-height: 64px;
    max-width: 160px;
  }

  /* Login: ocupa el resto */
  .seccion-login {
    width: 100%;
    padding: 28px 24px 32px;
  }

  .btn-regresar {
    top: 10px;
    left: 12px;
    color: var(--white) !important;
  }

  .btn-regresar .material-icons { font-size: 28px; }

  .titulo { font-size: 20px; }

  input { font-size: 14px; }

  .btn-login { font-size: 15px; padding: 12px; }
}

/* ---------- MÓVIL PEQUEÑO (≤480px) ---------- */
@media (max-width: 480px) {
  .contenedor-principal { padding: 12px; padding-top: 24px; }

  .seccion-login { padding: 20px 16px 28px; }

  .titulo { font-size: 18px; }

  input { font-size: 13px; padding: 9px 12px; }

  .btn-login { font-size: 14px; padding: 11px; }
}
  </style>
  